module.exports = __webpack_public_path__ + "img/empty-image.859d9f63.png";